import { tracked } from 'tracked-built-ins';
import Component from '@glimmer/component';
import type ActionModel from 'frontend/models/action';
import type TagModel from 'frontend/models/tag';
import { TagTypes } from 'common/enums/tag-type.enum';
import { BaseActionProductStatus } from 'common/enums/base-action-product-status.enum';

export interface PagesCatalogActionArgs {
  model: ActionModel;
}

export default class PagesCatalogAction extends Component<PagesCatalogActionArgs> {
  @tracked type: string = 'action';

  get tags() {
    return this.args.model.tags.length
      ? this.args.model.tags
      : this.args.model.get('product').get('tags');
  }

  get filteredTags() {
    return this.tags?.filter((tag: TagModel) => tag.type === TagTypes.One);
  }

  get isEnrolmentOpeningDateValid() {
    return this.args.model.status === BaseActionProductStatus.Published;
  }
}
